import { useRouter } from "next/router"
import Sticky from "react-stickynode"
import styled from "styled-components"
import axios from "axios"
import { themeGet } from "@styled-system/theme-get"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { getApiUrlLocale } from "@/helpers"
import ResetCSS from "@/common/assets/css/style"
import MetaData from "@/common/components/MetaData"
import NavbarNew from "@/containers/common/NavbarNew"
import Footer from "@/containers/common/FooterNew"
import SectionHeading from "@/common/components/SectionHeading"
import SectionLine from "@/common/components/SectionLine"
import Container from "@/common/components/UI/Container"
import { AppWrapper, ContentWrapper } from "@/containers/common/style"
import MediumArticleCard from "@/common/components/MediumArticleCard"

export const getStaticProps = async ({ locale }: any) => {
  const res = await axios(
    `${
      process.env.NEXT_PUBLIC_CMS_HOST
    }/api/events?populate=*&filters[event_identifier][identifier][$notNull]=true&locale=${getApiUrlLocale(
      locale
    )}&sort[0]=id%3Adesc&pagination[pageSize]=99`
  )
  const data = res.data

  return {
    props: {
      events: data,
      ...(await serverSideTranslations(locale, ["common", "contactUs"]))
    },
    revalidate: 300
  }
}

const Events = ({ events }: any) => {
  const { locale } = useRouter()
  const { t } = useTranslation("common")
  return (
    <div>
      <>
        <MetaData
          title={t("events.meta.title")}
          description={t("events.meta.description")}
          url={t("events.meta.url")}
          image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
          languageAlternates={[
            [
              {
                hrefLang: "en-US",
                href: "https://www.kryptogo.com/events"
              },
              {
                hrefLang: "zh-TW",
                href: "https://www.kryptogo.com/tw/events"
              },
              {
                hrefLang: "zh-CN",
                href: "https://www.kryptogo.com/cn/events"
              }
            ]
          ]}
        />

        <ResetCSS />
        {/* end of global and reset style */}

        {/* start app classic landing */}
        <AppWrapper>
          <Sticky top={0} innerZ={1000} activeClass="sticky-active">
            <NavbarNew />
          </Sticky>
          <Container>
            <TitleWrapper>
              <SectionHeading title={t("navbar.resources.events.title")} />
            </TitleWrapper>

            <ContentWrapper>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  width: "100%"
                }}
              >
                {events?.data?.map((item: any) => (
                  <EventCardWrapper key={item.id}>
                    <MediumArticleCard
                      t={t}
                      img={
                        item?.attributes?.cover_image?.data?.attributes?.formats
                          ?.medium?.url ||
                        item?.attributes?.cover_image?.data?.attributes?.url
                      }
                      title={item.attributes.name}
                      desc={item.attributes.description}
                      link={`${locale === "en" ? "" : `/${locale}`}/events/${
                        item.attributes["event_identifier"].data?.attributes
                          ?.identifier
                      }`}
                      linkText={item.attributes.external_link_text}
                      date={item.attributes.date}
                      linkType
                    />
                  </EventCardWrapper>
                ))}
              </div>
            </ContentWrapper>
            <SectionLine />
          </Container>
          <Footer />
        </AppWrapper>
      </>
    </div>
  )
}

export default Events
const TitleWrapper = styled.div`
  padding-top: 160px;
  @media (max-width: 768px) {
    padding-top: 100px;
  }
`
export const EventCardWrapper = styled.div`
  width: 50%;
  display: flex;
  padding: 2rem;
  align-items: start;
  @media screen and (max-width: 1200px) {
    padding: 1rem;
    margin-bottom: 1rem;
    flex: 0 1 50%;
    max-width: 50%;
  }
  @media screen and (max-width: 768px) {
    max-width: 400px;
    margin: 0 auto;
    flex: 0 1 100%;
    padding: 1rem 5px;
    width: 100%;
    border-bottom: 1px solid ${themeGet("colors.primaryLight")};
  }
`
